
/**
 * `MmeFlyout` - This component encapsulates the whole mme functionality that can be present in the header.
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { MmeComponent } from './HeaderMercedesMe.d';
import HeaderMercedesMeFlyout from './HeaderMercedesMeFlyout.vue';
import HeaderButton from '@owc-packages/Header/src/HeaderButton.vue';
import headerMixin from '@owc-utils/Mixins/Header';
import Logger from '@owc-utils/common/Logger';
import { store } from '@/store';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import {
  AUTHENTICATION_CONNECTION,
  CiasClaims,
  getClaims,
  getIdentityProvider,
  IdentityProvider,
  isLoggedIn,
  isPending,
} from '@b2x/authentication-library';

export default (ComponentInitializeDispatcher as MmeComponent).extend({
  name: 'owc-header-mercedes-me',
  components: {
    HeaderMercedesMeFlyout,
    HeaderButton,
    ValidationBoxWrapper,
  },
  mixins: [headerMixin, OwcDataComponent],
  data() {
    return {
      shouldShowFlyout: false,
      userData: null,
    };
  },
  created() {
    store.subscribe(AUTHENTICATION_CONNECTION, this.setUserData);
  },
  computed: {
    profileFlyoutAria() {
      return this.componentData?.profileFlyoutAria;
    },
    loginFlyoutAria() {
      return this.componentData?.loginFlyoutAria;
    },
    flyout() {
      return this.componentData?.flyout;
    },
  },
  methods: {
    toggleFlyoutVisibility() {
      if (!this.shouldShowFlyout) {
        this.closeHeaderFlyout(true);
      }

      this.shouldShowFlyout = !this.shouldShowFlyout;
    },
    closeFlyout(eventDetails) {
      const details = eventDetails.detail;

      if (!details?.isBackInteraction) {
        this.shouldShowFlyout = false;
      }
    },
    setUserData(state) {
      this.$nextTick(() => {
        const isStatePending = isPending(state);

        if (isStatePending) {
          this.userData = null;
          return;
        }

        const issuer = getIdentityProvider(state);
        const isUserLoggedIn = isLoggedIn(state);

        if (issuer === IdentityProvider.CIAS && isUserLoggedIn) {
          const { given_name: firstName, family_name: lastName } = getClaims(state) as CiasClaims;
          this.userData = {
            firstName,
            lastName,
          };
          Logger.debug('MME - login updated to:', state);
        } else {
          this.userData = null;
        }
      });
    },
  },
});
